import { Component, OnInit, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true,
    },
  ],
})
export class SliderComponent implements OnInit, ControlValueAccessor {
  @Input()
  theme: 'light' | 'dark' = 'dark';

  @Input()
  min = 0;

  @Input()
  max = 100;

  @Input()
  step = 1;

  @Input()
  public get value() {
    return this._value;
  }
  public set value(value) {
    if (value != null) {
      if (this._initialValue == null) {
        this._initialValue = value;
      }

      this._value = value;
      this.propagateChange(this.value);
    }
  }

  @Input()
  label: string = '';

  private _value = 0;
  private _initialValue;

  disabled = false;

  @Output()
  blurred = new EventEmitter();

  @Output()
  mouseUp = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  handleMouseUp() {
    this.mouseUp.emit();
  }

  handleBlur() {
    this.blurred.emit();
  }

  handleRangeDoubleClick() {
    this.value = this._initialValue;
  }

  // Both onChange and onTouched are functions
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  propagateChange = (_: any) => {};
}
